import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute  } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {DetailsPaymentsComponent} from '../details-payments/details-payments.component';
import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-manual-list',
  templateUrl: './manual-list.component.html',
  styleUrls: ['./manual-list.component.scss']
})
export class ManualListComponent implements OnInit {
  userId: any;
  userToken: any;
  uuid:any;
  listOrders: any = [];
  temp: any = [];
  load = true;
  expanded: any = {};
  @ViewChild('table', { static: false }) table: any;

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providerActive = 'hide';
  providersList=[];
  data: any = {};
  isExternal;
  perfilId;
  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];
  showContent:boolean=false;
  GuidFactura: string= null;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService,private route: ActivatedRoute) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    gralService.changeTextHead('LISTMANUALPAYMENT');

    //this.getOrders();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';
    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.data.FechaFin = new Date();
      this.GuidFactura = this.route.snapshot.paramMap.get('guid');
      if( this.GuidFactura ){
        this.searchFactura();
      }
      
  }
  /* ********************* filtros ************** */
  searchFactura(){
    
    this.data.Proveedor = this.arrOc.join();


    this.listOrders = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    //const params = {FechaFin: datePipe.transform(dateend, 'yyyy-MM-dd'), FechaInicio: datePipe.transform(dateinit, 'yyyy-MM-dd'), Proveedor: this.data.Proveedor, Sociedad: this.data.Sociedad, usuario: this.userId};
    const params = {
      FechaFin: "",
      FechaInicio:  "",
      Proveedor: "",
      Sociedad: "",
      GuidFactura : this.GuidFactura,
      usuario: this.userId
    };
    this.provService.getManualPayment(params, this.userToken).then((data) => {  
      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.showContent = true;
      if(this.listOrders.length == 0){
        this.toastr.success('No se encontraron resultados para su busqueda', 'Sin Datos');
        return false;
      }else{
        this.reorderDataExportExcel(this.listOrders);
      }
      
    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  /* ********************* filtros ************** */
  search(){
    
    this.data.Proveedor = this.arrOc.join();

    if(!this.data.Sociedad || !this.data.FechaInicio || !this.data.FechaFin){
      this.toastr.error('Favor de ingresar todos los campos', 'Error');
      return;
    }

    this.listOrders = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {FechaFin: datePipe.transform(dateend, 'yyyy-MM-dd'), FechaInicio: datePipe.transform(dateinit, 'yyyy-MM-dd'), Proveedor: this.data.Proveedor, Sociedad: this.data.Sociedad, usuario: this.userId};
    
    this.provService.getManualPayment(params, this.userToken).then((data) => {    
      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.showContent = true;
      if(this.listOrders.length == 0){
        this.toastr.success('No se encontraron resultados para su busqueda', 'Sin Datos');
        return false;
      }else{
        this.reorderDataExportExcel(this.listOrders);
      }
      
    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  disabledProv(){
    let resp = false;
    
    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;
        
      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }
  
  addProveedorSearch(option){
    console.log('option', option);
    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');      
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);
          
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){
    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];      
      this.arrOc.push(List[pos].NumProveedor);
    }
  }
  /* ********************* filtros ************** */

  /* ********************* checkbox ************** */
  checkedAll = false;
  selectAll(){
    for(let g = 0; g < this.listOrders.length; g++){
      this.listOrders[g].select = this.checkedAll;
      //this.sumTot();
    }
  }

  DescargaMasiva(){
    this.filterUUID((res)=>{
      console.warn(res);
      
      if(res.length >0){
        const _tempUUID = {uuid: res };
        this.provService.descargaMasiva(_tempUUID, 'llll').then((res:any)=>{
        this.loadBtn = false;
        if(res.resultado){
          let mimeType;
          if(res.Entidad.esPdf || res.Entidad.esXml ){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
            
            
            if(!res.Entidad.esZip){
              mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
            }else{
              mimeType =  '.zip';
            }
            
            let fileName= Date.now();
            let tempName = fileName+mimeType;

            saveAs(blob, tempName);
          }else if(res.Entidad.esZip){
            const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
            const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
            mimeType =  '.zip';
            let fileName= Date.now();
            let tempName = fileName+'.zip';

            saveAs(blob, tempName);
          }
        }


        });
      }else{
        this.toastr.info('Debe seleccionar al menos una factura', 'Descargar masiva');
      }
    })
    
  }
  
  /* ********************* Descarga ************** */
  
  download(pos){
    let fieldUUID = pos;
    
    this.provService.downloadFiles( fieldUUID,'111').then((res:any) => {
      
      if(res.resultado){
        if(res.Entidad.esPdf || res.Entidad.esXml ){
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
          
          let mimeType;
          if(!res.Entidad.esZip){
            mimeType = (res.Entidad.esPdf)?'.pdf': '.xml';
          }else{
            mimeType =  '.zip';
          }
          
          let fileName= Date.now();
          let tempName = fileName+mimeType;
          
          saveAs(blob, tempName);
        }else{ 
          const sampleBytes = this.base64ToArrayBuffer(res.Entidad.archivoBase64);
          const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });         
          let mimeType =  '.zip';          
          
          let fileName= Date.now();
          let tempName = fileName+mimeType;
          
          saveAs(blob, tempName);
        }
      }
    });   
  }

  filterUUID(callbak){
    let finalList = [];

    for(let i = 0; i < this.listOrders.length; i++ ){
      if(this.listOrders[i].select){
        let _UUID = this.listOrders[i].RecepcionFactura.UUID;
        finalList.push(_UUID);
      }
    }
    return callbak(finalList);
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  /*******************************   export to excel ***********************************/
  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('Factura_sin_documento'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    this.listExcel =  [];
    console.log('entro a reordenar',lista.length);
    
    for(let i = 0; i < lista.length; i++){
      let contTable = lista[i].RecepcionFactura;   
      let invoiceDocumentMiro = ""; 
      let yearMiro = "";
      if( lista[i].Resultado != null){
        invoiceDocumentMiro =  lista[i].Resultado.InvoiceDocumentMiro;
        yearMiro = lista[i].Resultado.InvoiceDocumentYearMiro;
      }  
      console.log(contTable.Folio);
      let params = {
          "Serie": contTable.Serie,
          "Folio": contTable.Folio,
          "RFC Emisor" : contTable.RFCEmisor,
          "Número de proveedor" : contTable.NumProveedor,
          "Fecha de emisión": contTable.FechaEmision,
          "Fecha de carga" : contTable.FechaCarga,
          "Estatus": contTable.EstatusProcesoFactura.Descripcion,      
          "Doc. Factura":  invoiceDocumentMiro ,
          "Año Doc. Factura": yearMiro
      }
      this.listExcel.push(params);
    }  
  }

  detail(uuid){
    console.log(this.uuid);
    this.provService.getOpenOrder(uuid, this.userToken).then((data) => {
      this.dialog.open(DetailsPaymentsComponent, {
        minWidth: '80%',
        position: {
          top: '6%'
        },
        data: { type: 'detail', info: data['Entidad'], id: uuid }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }
}
